if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

        setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

                if (this.querySelector("#productOptions")) {
          this.j =
            this.j ||
            JSON.parse(this.querySelector("#productOptions").textContent);
          this.v =
            this.v ||
            JSON.parse(this.querySelector("#productVariants").textContent);

          const m = mediaId.split("__main-")[1];

          let p = this.j.length - 1;
          const s =
            this.parentNode.nextElementSibling.querySelector("variant-selects");
          const o =
            this.parentNode.nextElementSibling.querySelector("variant-radios");

          if (this.hasAttribute("multiple-images")) {
            const a = activeMedia.querySelector("img").alt;

            if (s) {
              s.querySelectorAll("option").forEach((e) => {
                if (a == e.value) {
                  e.selected = true;
                  u(s);
                }
              });
            } else {
              o.querySelectorAll("input").forEach((e) => {
                if (a == e.value) {
                  e.checked = true;
                  u(o);
                } else {
                  e.checked = false;
                }
              });
            }
          } else {
              this.v.forEach((i) => {
                if (s && s.currentVariant && s.currentVariant.featured_media && s.currentVariant.featured_media.id === i.featured_media.id) {
                    return;
                }
                const t = i.featured_media && i.featured_media.id;
                if (t == m) {
                    if (s) {
                        if (i.options) {
                            i.options.forEach((optionText) => {
                                const option = Array.from(s.querySelectorAll("option")).find((op) => optionText == op.value);
                                if (option) {
                                    option.selected = true;
                                }
                            });
                            u(s);
                        }
                    } else {
                        o.querySelectorAll("input").forEach((t) => {
                            if (t.value.includes(i.options[p])) {
                                t.checked = true;
                                u(o);
                            }
                        });
                    }
                }
            });
        }
          function u(t) {
            t.updateOptions();
            t.updateMasterId();
            t.updateURL();
            t.checkOptions();
            t.updateVariantInput();
            t.renderProductInfo();
          }
        }

        
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
